// SearchOrder.js (نسخة الجدول المحسنة مع دفع كام؟ + Dropdown Menus)
import React, { useState, useEffect, useRef } from "react";
import { useOrderChangesDialog } from "../Components/orders/useOrderChangesDialog";
import OrderChangeImagesButton from "../Components/orders/OrderChangeImagesButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../utils/auth";
import { canViewOrders, canMutateOrders, canCreateTickets, canViewTickets, canCreateReplacements, isAdmin } from "../utils/roles";
import { searchOrdersByPhone, fetchOrderById, updateOrderStatus, revertToNew, deleteOrder, markOrderSentToFincart, sendSentToCartWhatsApp } from "../api/OrderAPIs";
import { fetchDesignById } from "../api/DesignAPIs";
import { fetchTypeById } from "../api/TypeAPIs";
import { readyOrderUnits, formatPhoneWithCaseStyle, teePlusPackedItemData, detailHasPersonalizedName } from "../utils/orderLineDisplay";
import { copyOrderToTeePlus } from "../utils/productionSource";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL_V2 } from "../api/URL_Header";
import { downloadCustomFile } from "../api/FileAPIs";
import { NamedPieceBadge } from "../Components/orders/NamedPieceBadge";
import StartConversationButton from "../Components/orders/StartConversationButton";
import OrderPaymentBadge, { isFulfillmentStatus, isPaidOnline, orderCanEnterFulfillment, unpaidFulfillmentMessage } from "../Components/orders/OrderPaymentBadge";
import ViewConversationButton from "../Components/orders/ViewConversationButton";
import ShippingTimeline from "../Components/orders/ShippingTimeline";
import OrderStatusHistoryButton from "../Components/orders/OrderStatusHistoryButton";
import CopyTrackingLinkButton, { CopyShippingLinkButton } from "../Components/orders/CopyTrackingLinkButton";
import ProductionSourceBadge from "../Components/orders/ProductionSourceBadge";
import ProductionHistoryButton from "../Components/orders/ProductionHistoryButton";
import { syncOrderShipping } from "../api/ShippingAPIs";
import EditOrderModal from "./Orders/EditOrderModal";
import OrderPieceDialogs from "./Orders/OrderPieceDialogs";
import MergeOrdersModal from "./Orders/MergeOrdersModal";
import {
  fetchFincartGovernorates,
  getDefaultPickupLocationId,
  sendOrderToFincart,
  saveFincartOrderId,
  getStoredFincartOrderId,
  FINCART_PAYMENT_OPTIONS,
} from "../api/FincartAPIs";
import { fetchTicketsForOrders } from "../api/TicketAPIs";
import ReplacementOrderWizard from "../Components/orders/ReplacementOrderWizard";
import {
  Search,
  Phone,
  MapPin,
  Calendar,
  DollarSign,
  Package,
  Copy,
  Download,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  AlertCircle,
  User,
  PhoneCall,
  Map,
  Hash,
  FileText,
  Trash2,
  Archive,
  Clock,
  CheckCircle,
  XCircle,
  AlertTriangle,
  RefreshCw,
  Copy as CopyIcon,
  Link as LinkIcon,
  Image as ImageIcon,
  Layers,
  MessageSquare,
  Truck,
  Heart,
  Filter,
  MoreVertical,
  Eye,
  EyeOff,
  CreditCard,
  Wallet,
  RotateCcw,
  Building2,
  Edit,
  Plus,
  Loader2,
  Printer,
  Shirt,
  Merge,
  Ticket,
} from "lucide-react";

// ==================== Number Input Dialog Component ====================
const NumberInputDialog = ({ isOpen, onClose, onConfirm, title, message }) => {
  const [value, setValue] = useState('');
  const inputRef = useRef(null);
  
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" style={{ zIndex: 9999 }}>
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl" dir="rtl">
        <h3 className="text-xl font-bold mb-2 text-gray-800">{title}</h3>
        <p className="text-gray-600 mb-4">{message}</p>
        <input
          ref={inputRef}
          type="number"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="w-full p-3 border-2 border-gray-300 rounded-xl text-center text-xl font-bold focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200"
          placeholder="أدخل المبلغ..."
          inputMode="numeric"
          pattern="[0-9]*"
        />
        <div className="flex gap-3 mt-4">
          <button
            onClick={() => {
              onConfirm(value);
              setValue('');
              onClose();
            }}
            className="flex-1 bg-orange-500 text-white py-2 rounded-xl hover:bg-orange-600 transition"
          >
            تأكيد
          </button>
          <button
            onClick={() => {
              setValue('');
              onClose();
            }}
            className="flex-1 bg-gray-300 text-gray-700 py-2 rounded-xl hover:bg-gray-400 transition"
          >
            إلغاء
          </button>
        </div>
      </div>
    </div>
  );
};

const ORDER_TYPE_OPTIONS = [
  { value: "delivery", label: "توصيل (delivery)" },
  { value: "exchange", label: "استبدال (exchange)" },
  { value: "return", label: "مرتجع (return)" },
];

// ==================== Resend to Fincart with new ID ====================
const ResendFincartModal = ({ isOpen, order, onClose, onConfirm, isSubmitting }) => {
  const defaultAmount = Number(order?.total) || 0;
  const [orderType, setOrderType] = useState("delivery");
  const [paymentType, setPaymentType] = useState(
    defaultAmount > 0 ? "with_cash_collection" : "without_cash_collection"
  );
  const [amount, setAmount] = useState(String(defaultAmount || ""));
  const [noOfItems, setNoOfItems] = useState(String(Math.max(order?.items?.length || 1, 1)));
  const [note, setNote] = useState("");

  useEffect(() => {
    if (!isOpen || !order) return;
    const amt = Number(order.total) || 0;
    setOrderType("delivery");
    setPaymentType(amt > 0 ? "with_cash_collection" : "without_cash_collection");
    setAmount(String(amt || ""));
    setNoOfItems(String(Math.max(order.items?.length || 1, 1)));
    setNote("");
  }, [isOpen, order]);

  const paymentOptions = FINCART_PAYMENT_OPTIONS[orderType] || FINCART_PAYMENT_OPTIONS.delivery;
  const selectedPayment = paymentOptions.find((p) => p.value === paymentType) || paymentOptions[0];
  const requiresAmount = !!selectedPayment?.requiresAmount;

  useEffect(() => {
    if (!paymentOptions.some((p) => p.value === paymentType)) {
      setPaymentType(paymentOptions[0].value);
    }
  }, [orderType]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isOpen || !order) return null;

  const handleSubmit = () => {
    const itemsCount = Math.max(parseInt(noOfItems, 10) || 0, 0);
    if (itemsCount < 1) {
      toast.error("عدد القطع لازم يكون 1 على الأقل");
      return;
    }

    const parsedAmount = requiresAmount ? Number(amount) : 0;
    if (requiresAmount && !(parsedAmount > 0)) {
      toast.error("المبلغ لازم يكون أكبر من صفر مع تحصيل الكاش");
      return;
    }

    onConfirm({
      orderType,
      paymentType: selectedPayment.value,
      amount: parsedAmount,
      noOfItems: itemsCount,
      note: note.trim(),
      forceNewReference: true,
    });
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4"
      style={{ zIndex: 9999 }}
      onClick={(e) => {
        if (e.target === e.currentTarget && !isSubmitting) onClose();
      }}
    >
      <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl max-h-[90vh] overflow-y-auto" dir="rtl">
        <h3 className="text-xl font-bold mb-1 text-gray-800">إعادة إرسال لـ Fincart</h3>
        <p className="text-sm text-gray-500 mb-4">
          الطلب #{order.orderNumber} — هيتبعت بـ reference ID جديد
        </p>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">نوع الطلب</label>
            <select
              value={orderType}
              onChange={(e) => setOrderType(e.target.value)}
              className="w-full p-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-cyan-500"
              disabled={isSubmitting}
            >
              {ORDER_TYPE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">نوع الدفع</label>
            <select
              value={selectedPayment.value}
              onChange={(e) => setPaymentType(e.target.value)}
              className="w-full p-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-cyan-500"
              disabled={isSubmitting}
            >
              {paymentOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          {requiresAmount && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">المبلغ للتحصيل</label>
              <input
                type="number"
                min="1"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="w-full p-3 border-2 border-gray-200 rounded-xl text-center text-lg font-bold focus:outline-none focus:border-cyan-500"
                disabled={isSubmitting}
                inputMode="numeric"
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">عدد القطع</label>
            <input
              type="number"
              min="1"
              value={noOfItems}
              onChange={(e) => setNoOfItems(e.target.value)}
              className="w-full p-3 border-2 border-gray-200 rounded-xl text-center text-lg font-bold focus:outline-none focus:border-cyan-500"
              disabled={isSubmitting}
              inputMode="numeric"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              ملاحظة (تُضاف للـ description)
            </label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={2}
              placeholder="اختياري..."
              className="w-full p-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-cyan-500 resize-none"
              disabled={isSubmitting}
            />
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="flex-1 bg-cyan-600 text-white py-3 rounded-xl font-bold hover:bg-cyan-700 transition disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {isSubmitting ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                جاري الإرسال...
              </>
            ) : (
              "إرسال بـ ID جديد"
            )}
          </button>
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-xl font-bold hover:bg-gray-300 transition disabled:opacity-50"
          >
            إلغاء
          </button>
        </div>
      </div>
    </div>
  );
};

// ==================== Hold Reason Dialog Component ====================
const HoldReasonDialog = ({ isOpen, onClose, onConfirm, orderId }) => {
  const OTHER_VALUE = "__OTHER__";
  const options = [
    { value: "ديبوزت , رفض قبل كده", label: "ديبوزت , رفض قبل كده" },
    { value: "عنوان", label: "عنوان" },
    { value: "هل هيدمج", label: "هل هيدمج" },
    { value: "الصوره مش واضحه يبعت واحده تانيه", label: "الصوره مش واضحه يبعت واحده تانيه" },
    { value: "ديبوزت", label: "ديبوزت" },
    { value: OTHER_VALUE, label: "حاجه تانيه" },
  ];

  const [selected, setSelected] = useState(options[0]?.value || "");
  const [customReason, setCustomReason] = useState("");
  const customRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setSelected(options[0]?.value || "");
    setCustomReason("");
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && selected === OTHER_VALUE && customRef.current) {
      customRef.current.focus();
    }
  }, [isOpen, selected]);

  if (!isOpen) return null;

  const finalReason = selected === OTHER_VALUE ? customReason.trim() : selected;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" style={{ zIndex: 9999 }}>
      <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl" dir="rtl">
        <h3 className="text-xl font-bold mb-2 text-gray-800">سبب التعليق (Hold)</h3>
        <p className="text-gray-600 mb-4">
          اختر سبب وضع الطلب #{orderId} على الانتظار:
        </p>

        <div className="space-y-3">
          <select
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
            className="w-full p-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-yellow-500 focus:ring-2 focus:ring-yellow-200 bg-white"
          >
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>

          {selected === OTHER_VALUE && (
            <input
              ref={customRef}
              type="text"
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
              className="w-full p-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-yellow-500 focus:ring-2 focus:ring-yellow-200"
              placeholder="اكتب السبب..."
            />
          )}
        </div>

        <div className="flex gap-3 mt-5">
          <button
            onClick={() => {
              onConfirm(finalReason);
              onClose();
            }}
            className="flex-1 bg-yellow-600 text-white py-2 rounded-xl hover:bg-yellow-700 transition"
            disabled={!finalReason}
          >
            تأكيد
          </button>
          <button
            onClick={() => onClose()}
            className="flex-1 bg-gray-300 text-gray-700 py-2 rounded-xl hover:bg-gray-400 transition"
          >
            إلغاء
          </button>
        </div>
      </div>
    </div>
  );
};

// ==================== Action Menu Dropdown Component ====================
const ActionMenu = ({
  icon: Icon,
  label,
  color = "slate",
  items = [],
  disabled = false,
  align = "right",
  size = "md",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isOpen]);

  const colorClasses = {
    slate: { bg: "bg-slate-600 hover:bg-slate-700", ring: "focus:ring-slate-300" },
    indigo: { bg: "bg-indigo-600 hover:bg-indigo-700", ring: "focus:ring-indigo-300" },
    purple: { bg: "bg-purple-600 hover:bg-purple-700", ring: "focus:ring-purple-300" },
    red: { bg: "bg-red-600 hover:bg-red-700", ring: "focus:ring-red-300" },
    emerald: { bg: "bg-emerald-600 hover:bg-emerald-700", ring: "focus:ring-emerald-300" },
  };
  const c = colorClasses[color] || colorClasses.slate;

  const sizeClasses = size === "sm" ? "px-2.5 py-2 text-xs" : "px-3 py-2.5 text-sm";

  return (
    <div className="relative" ref={menuRef}>
      <button
        type="button"
        onClick={() => !disabled && setIsOpen((p) => !p)}
        disabled={disabled}
        className={`w-full ${c.bg} text-white ${sizeClasses} rounded-xl font-medium flex items-center justify-center gap-1.5 active:scale-95 transition disabled:opacity-50 ${c.ring} focus:outline-none focus:ring-2`}
      >
        {Icon && <Icon size={size === "sm" ? 13 : 15} />}
        <span className="flex-1 text-center">{label}</span>
        <ChevronDown
          size={size === "sm" ? 12 : 14}
          className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div
          className={`absolute ${align === "right" ? "right-0" : "left-0"} top-full mt-1 z-50 min-w-[180px] bg-white rounded-xl shadow-2xl border border-gray-200 py-1 overflow-hidden`}
        >
          {items.map((item, idx) => (
            <button
              key={idx}
              type="button"
              onClick={() => {
                setIsOpen(false);
                item.onClick?.();
              }}
              disabled={item.disabled}
              title={item.title}
              className={`w-full text-right px-3 py-2.5 text-sm flex items-center gap-2 transition disabled:opacity-40 disabled:cursor-not-allowed ${
                item.danger ? "text-red-700 hover:bg-red-50" : "text-gray-800 hover:bg-slate-50"
              }`}
            >
              {item.icon && (
                <item.icon
                  size={14}
                  className={item.danger ? "text-red-500" : "text-slate-500"}
                />
              )}
              <span className="flex-1">{item.label}</span>
              {item.badge && (
                <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-600">
                  {item.badge}
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const SearchOrders = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { authState } = useAuth();
  const canAct = canMutateOrders(authState.role);
  const { changesDialog, openOrderChanges } = useOrderChangesDialog(async () => {
    await refreshSearch();
    toast.success('تم تحديث الطلب إلى "Changes" بنجاح!');
  });
  
  const canTicket = canCreateTickets(authState.role);
  const canSeeTickets = canViewTickets(authState.role);
  const canReplace = canCreateReplacements(authState.role);
  const [replacementOrderId, setReplacementOrderId] = useState(null);
  const [searchMode, setSearchMode] = useState("phone"); // "phone" | "orderId"
  const [phoneInput, setPhoneInput] = useState("");
  const [orderIdInput, setOrderIdInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [statusFilter, setStatusFilter] = useState("all");
  const [productionFilter, setProductionFilter] = useState("all");
  // collapse/expand state for mobile cards
  const [expandedOrders, setExpandedOrders] = useState(new Set());
  const autoSearchOrderIdRef = useRef(null);

  // States for Number Input Dialog
  const [showNumberDialog, setShowNumberDialog] = useState(false);
  const [pendingOrder, setPendingOrder] = useState(null);
  const [pendingTotal, setPendingTotal] = useState(null);

  // States for Hold Reason Dialog
  const [showHoldDialog, setShowHoldDialog] = useState(false);
  const [pendingHoldOrder, setPendingHoldOrder] = useState(null);

  // Edit order modal
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [pieceEdit, setPieceEdit] = useState(null);
  const [pieceDelete, setPieceDelete] = useState(null);
  const [pieceAddOrder, setPieceAddOrder] = useState(null);
  const [priceBump, setPriceBump] = useState(null);
  const [mergingOrder, setMergingOrder] = useState(null);
  const [sendingFincartOrderId, setSendingFincartOrderId] = useState(null);
  const [fincartMenuOrderId, setFincartMenuOrderId] = useState(null);
  const [resendFincartOrder, setResendFincartOrder] = useState(null);
  const adminUser = isAdmin(authState.role);

  const openTicketForOrder = (order) => {
    const latestTicketId = order.latestTicketId || order.tickets?.[0]?.id || order.tickets?.[0]?.Id;
    if (latestTicketId) {
      navigate(`/tickets/${latestTicketId}`);
      return;
    }
    const params = new URLSearchParams();
    params.set("orderId", String(order.orderNumber));
    const phone = order.phoneNumber && order.phoneNumber !== "غير معروف" ? order.phoneNumber : "";
    if (phone) params.set("phone", phone);
    navigate(`/tickets/create?${params.toString()}`);
  };

  const toggleExpand = (orderNumber) => {
    setExpandedOrders((prev) => {
      const next = new Set(prev);
      if (next.has(orderNumber)) {
        next.delete(orderNumber);
      } else {
        next.add(orderNumber);
      }
      return next;
    });
  };

  React.useEffect(() => {
    if (!canViewOrders(authState.role)) {
      navigate("/login");
    }
  }, [authState, navigate]);

  const normalizePhoneNumber = (phone) => {
    if (!phone) return phone;
    let cleaned = phone.replace(/[^\d+]/g, "");
    if (cleaned.startsWith("+")) cleaned = cleaned.slice(1);
    if (cleaned.startsWith("20") && cleaned.length === 12) cleaned = "0" + cleaned.slice(2);
    if (cleaned.startsWith("2") && cleaned.length === 11) cleaned = "0" + cleaned;
    if (cleaned.length === 10 && /^1[0125]/.test(cleaned)) cleaned = "0" + cleaned;
    return /^01[0125]\d{8}$/.test(cleaned) ? cleaned : phone.replace(/\D/g, "");
  };

  const handleDownload = async (url, filename = "design.jpg") => {
    try {
      await downloadCustomFile(url, filename);
    } catch (err) {
      console.error("Download failed:", err);
      toast.error("فشل التحميل");
    }
  };

  const enrichOrders = async (data) => {
    const enriched = await Promise.all(
      data.map(async (order) => {
        let enrichedItems = [];
        for (const detail of order.orderDetails) {
          const readyUnits = await readyOrderUnits(detail);
          if (readyUnits) {
            enrichedItems.push(...readyUnits);
            continue;
          }
          const design = await fetchDesignById(detail.designId);
          const type = await fetchTypeById(detail.typeId);
          if (!design || !type) continue;
          const baseItem = {
            id: detail.designId,
            orderDetailsId: detail.orderDetailsId,
            designId: detail.designId,
            typeId: detail.typeId,
            caseStyleId: detail.caseStyleId || detail.caseStyle?.caseStyleId || "",
            name: design.Name,
            price: detail.price,
            type: formatPhoneWithCaseStyle(type.name, detail),
            driveLink: design.code.startsWith("CUSTOM")
              ? `${API_BASE_URL_V2}${design.driveLink}`
              : design.driveLink || "",
            code: design.code || "None",
            customNameAr: detail.customNameAr || detail.CustomNameAr || "",
            customNameEn: detail.customNameEn || detail.CustomNameEn || "",
            hasPersonalizedName: detailHasPersonalizedName(detail),
          };
          for (let i = 0; i < detail.quantity; i++) {
            enrichedItems.push({
              ...baseItem,
              quantityIndex: i + 1,
              totalQuantity: detail.quantity,
            });
          }
        }
        const latestTicketId = order.latestTicketId ?? order.LatestTicketId ?? null;
        const ticketCount = Number(order.ticketCount ?? order.TicketCount ?? 0);
        const hasTicket = !!(order.hasTicket ?? order.HasTicket) || ticketCount > 0 || !!latestTicketId;
        return {
          orderNumber: order.orderId ?? order.OrderId,
          hasTicket,
          ticketCount,
          latestTicketId,
          tickets: [],
          items: enrichedItems,
          total: order.totalAmount,
          profit: order.profit || 0,
          date: new Date(order.date).toISOString().split("T")[0],
          address: order.address?.fullAddress || "غير معروف",
          state: order.address?.state || "غير معروف",
          city: order.address?.city || "",
          apartment: order.address?.apartment || "",
          phoneNumber: order.phoneNumber || "غير معروف",
          phoneNumber2: order.phoneNumber2 || "غير معروف",
          name: order.name || "غير معروف",
          note: order.note || "",
          changeNoteImageCount: Number(order.changeNoteImageCount || 0),
          status: order.status || "غير معروف",
          paymentMethod: order.paymentMethod || "COD",
          paymentStatus: order.paymentStatus || "NotRequired",
          paymentTransactionId: order.paymentTransactionId || "",
          productionSource: order.productionSource || order.ProductionSource || null,
          sentToFincart: !!order.sentToFincart || !!order.shippingOrderId || !!getStoredFincartOrderId(order.orderId),
          fincartOrderId: order.shippingOrderId || getStoredFincartOrderId(order.orderId),
          shippingProvider: order.shippingProvider || null,
          shippingState: order.shippingState || null,
          shippingStatus: order.shippingStatus || null,
          shippingSubStatus: order.shippingSubStatus || null,
          trackingNumber: order.trackingNumber || null,
          shippingTrackLink: order.shippingTrackLink || null,
          lastShippingSyncAt: order.lastShippingSyncAt || null,
          deliveredAt: order.deliveredAt || null,
          returnedAt: order.returnedAt || null,
        };
      })
    );

    if (!canSeeTickets && !canTicket) return enriched;
    try {
      const grouped = await fetchTicketsForOrders(
        enriched.map((o) => o.orderNumber).filter((id) => Number(id) > 0)
      );
      const byOrderId = new Map(
        (Array.isArray(grouped) ? grouped : []).map((row) => [
          Number(row.orderId ?? row.OrderId),
          row.tickets || row.Tickets || [],
        ])
      );
      return enriched.map((o) => {
        const tickets = byOrderId.get(Number(o.orderNumber)) || o.tickets || [];
        const latest = tickets[0];
        const latestTicketId = latest?.id ?? latest?.Id ?? o.latestTicketId ?? null;
        const ticketCount = tickets.length || o.ticketCount || 0;
        return {
          ...o,
          tickets,
          ticketCount,
          hasTicket: o.hasTicket || tickets.length > 0 || !!latestTicketId,
          latestTicketId,
          latestTicketStatus: latest?.status ?? latest?.Status ?? o.latestTicketStatus ?? null,
        };
      });
    } catch (err) {
      console.error("Failed to attach tickets to search results", err);
      return enriched;
    }
  };

  const backfillShippingIds = async (orders) => {
    const missing = (orders || []).filter(
      (o) => !o.shippingOrderId && getStoredFincartOrderId(o.orderNumber)
    );
    for (const order of missing) {
      const storedId = getStoredFincartOrderId(order.orderNumber);
      try {
        await markOrderSentToFincart(order.orderNumber, true, {
          shippingOrderId: storedId,
        });
      } catch (err) {
        console.error("فشل حفظ Fincart ID من المتصفح:", err);
      }
    }
  };

  const handleSearch = async () => {
    if (searchMode === "orderId") {
      const orderId = orderIdInput.trim();
      if (!orderId) {
        toast.error("يرجى إدخال رقم الطلب");
        return;
      }
      if (!/^\d+$/.test(orderId)) {
        toast.error("رقم الطلب يجب أن يكون أرقام فقط");
        return;
      }
    } else if (!phoneInput.trim()) {
      toast.error("يرجى إدخال رقم هاتف");
      return;
    }

    setIsSearching(true);
    setSearchError(null);
    setSearchResults([]);
    setExpandedOrders(new Set());
    try {
      let rawResults;
      if (searchMode === "orderId") {
        const order = await fetchOrderById(orderIdInput.trim());
        rawResults = [order];
      } else {
        const normalizedPhone = normalizePhoneNumber(phoneInput);
        rawResults = await searchOrdersByPhone(normalizedPhone);
      }
      const enrichedResults = await enrichOrders(rawResults);
      setSearchResults(enrichedResults);
      backfillShippingIds(enrichedResults);
      toast.success("تم البحث بنجاح");
    } catch (err) {
      setSearchError(
        searchMode === "orderId"
          ? "لا يوجد اوردر برقم الطلب ده"
          : "لا يوجد اوردر بالرقم ده"
      );
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    const orderIdFromQuery = searchParams.get("orderId");
    if (!orderIdFromQuery || !/^\d+$/.test(orderIdFromQuery)) return;
    if (autoSearchOrderIdRef.current === orderIdFromQuery) return;
    autoSearchOrderIdRef.current = orderIdFromQuery;

    setSearchMode("orderId");
    setOrderIdInput(orderIdFromQuery);

    (async () => {
      setIsSearching(true);
      setSearchError(null);
      setSearchResults([]);
      setExpandedOrders(new Set());
      try {
        const order = await fetchOrderById(orderIdFromQuery);
        const enrichedResults = await enrichOrders([order]);
        setSearchResults(enrichedResults);
        backfillShippingIds(enrichedResults);
      } catch {
        setSearchError("لا يوجد اوردر برقم الطلب ده");
      } finally {
        setIsSearching(false);
      }
    })();
  }, [searchParams]);

  const refreshSearch = async () => {
    try {
      let rawResults;
      if (searchMode === "orderId") {
        if (!orderIdInput.trim()) return;
        const order = await fetchOrderById(orderIdInput.trim());
        rawResults = [order];
      } else {
        if (!phoneInput.trim()) return;
        const normalizedPhone = normalizePhoneNumber(phoneInput);
        rawResults = await searchOrdersByPhone(normalizedPhone);
      }
      const enrichedResults = await enrichOrders(rawResults);
      setSearchResults(enrichedResults);
      backfillShippingIds(enrichedResults);
    } catch (err) {
      toast.error("فشل في إعادة تحميل النتائج");
    }
  };

  // ==================== NEW: Handle Partial Payment (دفع كام؟) ====================
  const handlePartialPaymentClick = (orderId, orderTotal) => {
    if (!canAct) return;
    setPendingOrder(orderId);
    setPendingTotal(orderTotal);
    setShowNumberDialog(true);
  };

  const handleNumberConfirm = async (paidAmount) => {
    if (!canAct) return;
    if (!paidAmount || paidAmount.trim() === "") {
      toast.error("يجب إدخال المبلغ المدفوع!");
      return;
    }

    const paidNumber = parseFloat(paidAmount);
    if (isNaN(paidNumber) || paidNumber <= 0) {
      toast.error("يرجى إدخال رقم صحيح للمبلغ المدفوع!");
      return;
    }

    const totalAmount = parseFloat(pendingTotal);
    if (paidNumber > totalAmount) {
      toast.error("المبلغ المدفوع أكبر من تكلفة الأوردر!");
      return;
    }
    const remainingAmount = totalAmount - paidNumber;
    const paymentNote = `دفع ${paidNumber} و الحساب ${remainingAmount}`;

    const confirmMessage =
      `تأكيد:\n` +
      `العميل دفع: ${paidNumber} ج\n` +
      `تكلفة الأوردر الجديدة: ${remainingAmount} ج\n` +
      `الحالة: Changes\n` +
      `الملاحظة: "${paymentNote}"\n\nهل أنت متأكد؟`;
    if (!window.confirm(confirmMessage)) return;

    try {
      await updateOrderStatus(pendingOrder, "Changes", paymentNote, null, { paidAmount: paidNumber });
      await refreshSearch();
      toast.success(`تم تحديث الطلب إلى "تغييرات" وتعديل التكلفة إلى ${remainingAmount} ج (بعد خصم ${paidNumber} ج)!`);
    } catch (err) {
      console.error("Error in handlePartialPayment:", err);
      toast.error("فشل التحديث: " + (err.message || "خطأ غير معروف"));
    }
  };

  // ==================== NEW: Handle Normal Changes (تغييرات عادي) ====================
  const handleNormalChanges = async (orderId) => {
    if (!canAct) return;
    openOrderChanges(orderId);
  };

  const openHoldDialog = (orderId) => {
    setPendingHoldOrder(orderId);
    setShowHoldDialog(true);
  };

  const handleHoldReasonConfirm = async (reason) => {
    if (!canAct) return;
    const finalReason = (reason || "").trim();
    if (!finalReason) {
      toast.error("يجب اختيار/كتابة سبب");
      return;
    }

    const confirmUpdate = window.confirm(`هل أنت متأكد من تحديث الحالة إلى Hold؟\n\nالسبب: "${finalReason}"`);
    if (!confirmUpdate) return;

    try {
      await updateOrderStatus(pendingHoldOrder, "Hold", finalReason);
      toast.success(`تم تحديث الطلب إلى Hold`);
      await refreshSearch();
    } catch (err) {
      toast.error("فشل في تحديث الطلب");
    }
  };

  // ==================== MODIFIED: handleUpdateStatus ====================
  const handleUpdateStatus = async (id, status) => {
    if (!canAct) return;
    const targetOrder = searchResults.find((order) => order.orderNumber === id);
    if (isFulfillmentStatus(status) && !orderCanEnterFulfillment(targetOrder)) {
      toast.error(unpaidFulfillmentMessage(targetOrder || { orderNumber: id }));
      return;
    }
    if (isPaidOnline(targetOrder) && (status === "Deposit Required" || status === "Deposit" || status === "Custom" || status === "Custom Order")) {
      toast.error(`Order #${id} is already paid online. A deposit is not required.`);
      return;
    }
    let reason = "no reason";

    if (status === "Changes") {
      handleNormalChanges(id);
      return;
    }

    if (status === "Hold") {
      openHoldDialog(id);
      return;
    } else if (status === "Under Purchase") {
      reason = prompt("ادخل الاوردر ريفرنس Girabtcom.xxx:");
      if (reason === null) return;
      if (!reason.trim()) { toast.error("يجب إدخال الريفيرنس"); return; }
    } else if (status === "Spam") {
      reason = prompt("يرجى إدخال السبب:");
      if (reason === null) return;
      if (!reason.trim()) { toast.error("يجب إدخال سبب"); return; }
    } else if (status === "Incomplete") {
      const note = prompt(
        "ملاحظة Incomplete (اختياري) — السبب أو نوع الجراب الناقص:\nاتركه فاضي لو مش عايز تكتب حاجة"
      );
      if (note === null) return;
      reason = note.trim() || "no reason";
    }

    const confirmUpdate = window.confirm(`هل أنت متأكد من تحديث الحالة إلى ${status}؟`);
    if (!confirmUpdate) return;

    try {
      await updateOrderStatus(id, status, reason);
      toast.success(`تم تحديث الطلب إلى ${status}`);
      await refreshSearch();
    } catch (err) {
      toast.error("فشل في تحديث الطلب");
    }
  };

  const handleDeleteOrder = async (id) => {
    if (!canAct) return;
    if (!window.confirm("هل أنت متأكد من حذف هذا الطلب؟")) return;
    try {
      await deleteOrder(id);
      toast.success("تم حذف الطلب بنجاح");
      await refreshSearch();
    } catch (err) {
      toast.error("فشل في حذف الطلب");
    }
  };

  const handleOrderEdited = async (updatedOrder) => {
    if (!updatedOrder?.orderId) {
      await refreshSearch();
      return;
    }
    try {
      const [enriched] = await enrichOrders([updatedOrder]);
      setSearchResults((prev) =>
        prev.map((o) => (o.orderNumber === enriched.orderNumber ? enriched : o))
      );
    } catch (err) {
      console.error(err);
      await refreshSearch();
    }
  };

  const handleOrdersMerged = async (updatedOrder, otherOrderId) => {
    try {
      const [enriched] = await enrichOrders([updatedOrder]);
      setSearchResults((prev) =>
        prev.map((o) => {
          if (o.orderNumber === enriched.orderNumber) return enriched;
          if (o.orderNumber === otherOrderId) {
            const mergeNote = `تم الدمج مع ${enriched.orderNumber}`;
            return {
              ...o,
              status: "Old",
              note: o.note ? `${o.note} || ${mergeNote}` : mergeNote,
            };
          }
          return o;
        })
      );
    } catch (err) {
      console.error(err);
      await refreshSearch();
    }
  };

  const handleSendToFincart = async (order) => {
    if (!adminUser) return;

    if (order.sentToFincart || order.fincartOrderId) {
      toast.info(`الطلب #${order.orderNumber} مُرسل لـ Fincart بالفعل`);
      return;
    }

    if (!order.city?.trim()) {
      toast.error(
        `الطلب #${order.orderNumber} بدون مدينة/منطقة من قائمة Fincart — عدّل العنوان أولاً`
      );
      return;
    }

    const confirmed = window.confirm(
      `إرسال الطلب #${order.orderNumber} إلى Fincart للشحن؟\n\nلن يتم تغيير حالة الطلب — حدّث يدوياً بعدين.`
    );
    if (!confirmed) return;

    await executeSendToFincart(order);
  };

  const handleResendToFincart = async (options) => {
    if (!adminUser || !resendFincartOrder) return;
    await executeSendToFincart(resendFincartOrder, options);
  };

  const executeSendToFincart = async (order, options = {}) => {
    if (!order.city?.trim()) {
      toast.error(
        `الطلب #${order.orderNumber} بدون مدينة/منطقة من قائمة Fincart — عدّل العنوان أولاً`
      );
      return;
    }

    const isResend = !!options.forceNewReference;
    setSendingFincartOrderId(order.orderNumber);
    toast.info(isResend ? "جاري إعادة الإرسال إلى Fincart..." : "جاري الإرسال إلى Fincart...", {
      autoClose: false,
      toastId: "fincart-send-search",
    });

    try {
      const [pickupLocationId, governorates] = await Promise.all([
        getDefaultPickupLocationId(),
        fetchFincartGovernorates(),
      ]);

      const result = await sendOrderToFincart(
        order,
        pickupLocationId,
        governorates,
        options
      );
      const fincartOrderId = result?.fincartOrderId || result?.data?.orderId || null;
      const trackingNumber = result?.trackingNumber || result?.orderCode || null;
      const alreadyInFincart = !!result?.alreadyInFincart;

      if (fincartOrderId) {
        saveFincartOrderId(order.orderNumber, fincartOrderId);
      }

      try {
        await markOrderSentToFincart(order.orderNumber, true, {
          shippingOrderId: fincartOrderId,
          trackingNumber,
          shippingTrackLink: result?.trackingUrl || null,
        });
      } catch (persistErr) {
        console.error("فشل حفظ SentToFincart:", persistErr);
      }

      if (fincartOrderId) {
        try {
          await syncOrderShipping(order.orderNumber);
        } catch (syncErr) {
          console.error("فشل مزامنة حالة الشحن:", syncErr);
        }
      }

      // WhatsApp only on first send (not resend with new id)
      if (!isResend && order.phoneNumber) {
        try {
          await sendSentToCartWhatsApp(order.phoneNumber);
        } catch (waErr) {
          console.error("فشل إرسال تمبلت sent_to_cart:", waErr);
          toast.warning(
            "تم الإرسال لـ Fincart لكن فشل إرسال رسالة واتساب (sent_to_cart) للعميل"
          );
        }
      }

      setSearchResults((prev) =>
        prev.map((o) =>
          o.orderNumber === order.orderNumber
            ? {
                ...o,
                fincartOrderId: fincartOrderId || o.fincartOrderId,
                sentToFincart: true,
              }
            : o
        )
      );

      toast.dismiss("fincart-send-search");
      if (!fincartOrderId) {
        toast.warning(
          `Fincart قبل الطلب #${order.orderNumber} لكن مردش برقم الشحن. المزامنة هتحاول ترجّعه.`
        );
      }
      if (alreadyInFincart) {
        toast.warning(
          `الطلب #${order.orderNumber} كان موجود في Fincart (مكرر)` +
            (result?.data?.orderCode ? `\n${result.data.orderCode}` : "") +
            (result?.referenceNumber ? `\nRef: ${result.referenceNumber}` : "")
        );
      } else {
        toast.success(
          (isResend
            ? `تم إعادة إرسال الطلب #${order.orderNumber} إلى Fincart بـ ID جديد`
            : `تم إرسال الطلب #${order.orderNumber} إلى Fincart`) +
            (result?.data?.orderCode ? `\n${result.data.orderCode}` : "") +
            (result?.referenceNumber ? `\nRef: ${result.referenceNumber}` : "")
        );
      }

      if (isResend) {
        setResendFincartOrder(null);
      }
    } catch (err) {
      console.error(`Fincart failed #${order.orderNumber}:`, err);
      toast.dismiss("fincart-send-search");
      toast.error(err.message || "فشل الإرسال إلى Fincart");
    } finally {
      setSendingFincartOrderId(null);
      setFincartMenuOrderId(null);
    }
  };

  const copyToClipboard = (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        toast.success("تم النسخ بنجاح!");
      }).catch(() => fallbackCopy(text));
    } else {
      fallbackCopy(text);
    }
  };

  const fallbackCopy = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      toast.success("تم النسخ بنجاح!");
    } catch (err) {
      toast.error("فشل النسخ");
    }
    document.body.removeChild(textArea);
  };

  const handleCopyOrderInfo = (order) => {
    const phone = `${order.phoneNumber}${order.phoneNumber2 !== "غير معروف" ? ` - ${order.phoneNumber2}` : ""}`;
    const text = `${order.name}\t${phone}\t\t${order.address}\t${order.state}\t${order.total}\tCOD`;
    copyToClipboard(text);
  };

  const handleCopyItems = (order) => {
    const lines = order.items.map((item, index) => {
      return `${index + 1}-${order.items.length}\t\tPhone Cover (H)\t${item.type}\t\t1\t${item.driveLink || "No Link"}`;
    }).join("\n");
    copyToClipboard(lines);
  };

  const handleCopyAllExcelDataNoReference = async (order) => {
    if (!orderCanEnterFulfillment(order)) {
      toast.error(unpaidFulfillmentMessage(order));
      return;
    }
    try {
      const phone = `${order.phoneNumber}${
        order.phoneNumber2 && order.phoneNumber2 !== "غير معروف" ? "-" + order.phoneNumber2 : ""
      }`;
      const formattedState = `${order.state} (D)`;
      const customerBase = `${order.name}\t${phone}\t\t${order.address}\t${formattedState}\t${order.total}\tCOD\t`;
      const items = order.items;
      const lines = [];
      items.forEach((item, index) => {
        const itemNum = `${index + 1}-${items.length}`;
        const itemData = teePlusPackedItemData(item);
        const itemLine = `${itemNum}${itemData}`;
        if (index === 0) {
          lines.push(`${customerBase}\t\t${itemLine}`);
        } else {
          lines.push(`\t\t\t\t\t\t\t\t\t${itemLine}`);
        }
      });
      await copyOrderToTeePlus(lines.join("\n"), order.orderNumber);
      toast.success("تم النسخ بنجاح!");
      setSearchResults((prev) =>
        prev.map((o) =>
          o.orderNumber === order.orderNumber ? { ...o, productionSource: "TeePlus" } : o
        )
      );
    } catch (err) {
      console.error("خطأ في النسخ:", err);
      if (err.code === "SOURCE_FAILED") {
        toast.warn("تم النسخ إلى TeePlus، لكن تعذر تحديث مصدر الإنتاج");
      } else {
        toast.error("فشل في النسخ، حاول مرة تانية");
      }
    }
  };

  const handleCopyConfirmationMessage = (order) => {
    const itemsList = order.items.map((item) => `Types : ${item.type} - Code : ${item.code}`).join("\n");
    const message = `أهلا بحضرتك" 🌸\nمع حضرتك فاطمة من فريق جرابتكم ستور 💛\nبنراجع مع حضرتك الطلب قبل بدء تنفيذه، لأن التصميمات بتتعمل مخصوص لحضرتك حسب الطلب 🎨✨\n\nتفاصيل الطلب:\n${itemsList}\n\nبمجرد تأكيد حضرتك هنبدأ تنفيذ وتجهيز الأوردر فورًا 🚚⚡\n\nلتأكيد الطلب بشكل نهائي برجاء الرد بــ:\n( نعم - تأكيد ) ✅\n\nوفي حالة الرغبة في التعديل أو الإلغاء برجاء إبلاغنا قبل البدء 💬\nشكرًا لاختيار حضرتك جرابتكم 🤍🌷`;
    copyToClipboard(message);
  };

  const handleCopyBostaMessage = () => {
    const message = `أهلاً وسهلاً!\n\nبنحب نبلغ حضرتك إن شركة الشحن هتتواصل مع حضرتك على الواتساب خلال وقت قصير لتأكيد العنوان واستلام الطلب ✅\n\nتنويه مهم:\nفي رسالة التأكيد اللي هتوصلك ممكن تلاقي اسم شركة مختلفة (مثل TeePlus) 💼  \n\nكمان عدد القطع ممكن يظهر 1 حتى لو كانت اكتر من قطعة واحدة 🧾\n\nيُرجى الرد على رسالة شركة الشحن علشان يتم تأكيد الطلب ويتم بدءالشحن ✉️⚡  \n\nشكرًا لاختيارك جرابتكم 🌷`;
    copyToClipboard(message);
  };

  const handleCopyApologyMessage = () => {
    const message = `أهلاً بحضرتك 🌸\nمع حضرتك فاطمة من جرابتكم ستور 💛\n\nبنعتذر جداً عن التأخير في تنفيذ الطلب الفترة اللي فاتت،\nكان فيه نقص في نوع الجراب المطلوب، لكن الحمد لله تم توفيره الآن وجاهز للتنفيذ ✅\n\nهل نبدأ في تجهيز الطلب فوراً؟ \n\nنقدّر جداً صبرك وذوقك ❤️\nفاطمة - فريق جرابتكم`;
    copyToClipboard(message);
  };

  const displayOrderStatus = (status) => {
    if (String(status || "").toLowerCase() === "girabatcom") return "printing";
    return status;
  };

  const getStatusColor = (status) => {
    const colors = {
      "جديد": "bg-blue-100 text-blue-700 border-blue-200",
      "معلق": "bg-yellow-100 text-yellow-700 border-yellow-200",
      "تغييرات": "bg-purple-100 text-purple-700 border-purple-200",
      "تحت الشراء": "bg-orange-100 text-orange-700 border-orange-200",
      "مؤكد": "bg-green-100 text-green-700 border-green-200",
      "قديم": "bg-gray-100 text-gray-700 border-gray-200",
      "ملغي": "bg-red-100 text-red-700 border-red-200",
      "Spam": "bg-red-100 text-red-700 border-red-200",
      "ديبوزت": "bg-indigo-100 text-indigo-700 border-indigo-200",
      "Girabatcom": "bg-indigo-100 text-indigo-700 border-indigo-200",
      "Printing Hold": "bg-slate-100 text-slate-700 border-slate-200",
      "Printlet": "bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200",
      "TeePlus": "bg-emerald-100 text-emerald-700 border-emerald-200",
      "Printed": "bg-teal-100 text-teal-700 border-teal-200",
      "Incomplete": "bg-amber-100 text-amber-700 border-amber-200",
      "Confirmed": "bg-green-100 text-green-700 border-green-200",
      "Canceled": "bg-red-100 text-red-700 border-red-200",
      "Hold": "bg-yellow-100 text-yellow-700 border-yellow-200",
      "New": "bg-blue-100 text-blue-700 border-blue-200",
      "Old": "bg-gray-100 text-gray-700 border-gray-200",
      "Changes": "bg-purple-100 text-purple-700 border-purple-200",
      "Deposit Required": "bg-indigo-100 text-indigo-700 border-indigo-200",
      "Under Purchase": "bg-orange-100 text-orange-700 border-orange-200",
      "غير معروف": "bg-gray-100 text-gray-700 border-gray-200",
    };
    return colors[status] || "bg-gray-100 text-gray-700 border-gray-200";
  };

  const filteredResults = searchResults.filter((order) => {
    if (statusFilter !== "all" && order.status !== statusFilter) return false;
    if (productionFilter === "unassigned") return !order.productionSource;
    if (productionFilter !== "all" && order.productionSource !== productionFilter) return false;
    return true;
  });

  // Production menu items (reused in mobile + desktop)
  const productionMenuItems = (order) => {
    const unpaid = !orderCanEnterFulfillment(order);
    const blockedTitle = unpaid ? "Payment Pending" : undefined;
    return [
    { label: "Girabatcom", icon: Building2, disabled: unpaid, title: blockedTitle, onClick: () => handleUpdateStatus(order.orderNumber, "Girabatcom") },
    { label: "Printing Hold", icon: Printer, disabled: unpaid, title: blockedTitle, onClick: () => handleUpdateStatus(order.orderNumber, "Printing Hold") },
    { label: "Tee Plus", icon: Shirt, disabled: unpaid, title: blockedTitle, onClick: () => handleUpdateStatus(order.orderNumber, "TeePlus") },
    { label: "Printed", icon: CheckCircle, disabled: unpaid, title: blockedTitle, onClick: () => handleUpdateStatus(order.orderNumber, "Printed") },
    { label: "Incomplete", icon: AlertTriangle, disabled: unpaid, title: blockedTitle, onClick: () => handleUpdateStatus(order.orderNumber, "Incomplete") },
  ];
  };

  // Order status menu items
  const orderStatusMenuItems = (order) => [
    { label: "مؤكد", icon: CheckCircle, disabled: !orderCanEnterFulfillment(order), title: orderCanEnterFulfillment(order) ? undefined : "Payment Pending", onClick: () => handleUpdateStatus(order.orderNumber, "Confirmed") },
    { label: "ملغي", icon: XCircle, onClick: () => handleUpdateStatus(order.orderNumber, "Canceled") },
    { label: "معلق", icon: Clock, onClick: () => handleUpdateStatus(order.orderNumber, "Hold") },
    { label: "إعادة لجديد", icon: RefreshCw, onClick: () => handleUpdateStatus(order.orderNumber, "New") },
    { label: "قديم", icon: Archive, onClick: () => handleUpdateStatus(order.orderNumber, "Old") },
    { label: "ديبوزت", icon: DollarSign, disabled: isPaidOnline(order), title: isPaidOnline(order) ? "تم الدفع أونلاين" : undefined, onClick: () => handleUpdateStatus(order.orderNumber, "Deposit Required") },
  ];

  // Danger menu items
  const dangerMenuItems = (order) => [
    { label: "حذف الطلب", icon: Trash2, onClick: () => handleDeleteOrder(order.orderNumber), danger: true },
    { label: "Spam", icon: AlertTriangle, onClick: () => handleUpdateStatus(order.orderNumber, "Spam"), danger: true },
  ];

  const renderPieceActions = (order, item) => {
    if (!canAct || !item.orderDetailsId || item.quantityIndex !== 1) return null;
    return (
      <div className="mt-2 space-y-1">
        {item.totalQuantity > 1 && (
          <p className="text-[10px] text-gray-500">الكمية {item.totalQuantity} — التعديل والحذف على القطعة كلها</p>
        )}
        <div className="flex gap-1.5">
          <button
            type="button"
            onClick={() => setPieceEdit({ orderNumber: order.orderNumber, item })}
            className="flex-1 bg-blue-600 text-white py-1.5 rounded-lg text-[11px] font-bold flex items-center justify-center gap-1"
          >
            <Edit size={12} />
            تعديل
          </button>
          <button
            type="button"
            onClick={() => setPieceDelete({ orderNumber: order.orderNumber, item })}
            className="flex-1 bg-red-600 text-white py-1.5 rounded-lg text-[11px] font-bold flex items-center justify-center gap-1"
          >
            <Trash2 size={12} />
            حذف
          </button>
        </div>
      </div>
    );
  };

  const renderAddPiece = (order) => {
    if (!canAct) return null;
    return (
      <button
        type="button"
        onClick={() => setPieceAddOrder(order.orderNumber)}
        className="w-full mt-2 border-2 border-dashed border-purple-300 text-purple-700 bg-purple-50 py-2 rounded-xl text-sm font-bold flex items-center justify-center gap-1"
      >
        <Plus size={14} />
        إضافة قطعة
      </button>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 p-4 md:p-8" dir="rtl">
      {changesDialog}
      <ToastContainer position="top-center" />

      {/* Number Input Dialog */}
      <NumberInputDialog
        isOpen={showNumberDialog}
        onClose={() => {
          setShowNumberDialog(false);
          setPendingOrder(null);
          setPendingTotal(null);
        }}
        onConfirm={handleNumberConfirm}
        title="دفعة العميل"
        message="أدخل المبلغ الذي دفعه العميل:"
      />

      {/* Hold Reason Dialog */}
      <HoldReasonDialog
        isOpen={showHoldDialog}
        orderId={pendingHoldOrder}
        onClose={() => {
          setShowHoldDialog(false);
          setPendingHoldOrder(null);
        }}
        onConfirm={handleHoldReasonConfirm}
      />

      {editingOrderId && (
        <EditOrderModal
          orderId={editingOrderId}
          onClose={() => setEditingOrderId(null)}
          onSaved={handleOrderEdited}
        />
      )}

      <OrderPieceDialogs
        editTarget={pieceEdit}
        deleteTarget={pieceDelete}
        addOrderNumber={pieceAddOrder}
        priceBump={priceBump}
        onCloseEdit={() => setPieceEdit(null)}
        onCloseDelete={() => setPieceDelete(null)}
        onCloseAdd={() => setPieceAddOrder(null)}
        onClosePrice={() => setPriceBump(null)}
        onChanged={handleOrderEdited}
        onAdded={(updated) => {
          handleOrderEdited(updated);
          setPieceAddOrder(null);
          setPriceBump({
            orderNumber: updated?.orderId ?? updated?.OrderId ?? pieceAddOrder,
            oldTotal: Number(updated?.totalAmount ?? updated?.TotalAmount) || 0,
          });
        }}
      />

      <ReplacementOrderWizard
        open={!!replacementOrderId}
        orderId={replacementOrderId}
        onClose={() => setReplacementOrderId(null)}
      />

      {mergingOrder && (
        <MergeOrdersModal
          sourceOrder={mergingOrder}
          onClose={() => setMergingOrder(null)}
          onMerged={handleOrdersMerged}
        />
      )}

      <ResendFincartModal
        isOpen={!!resendFincartOrder}
        order={resendFincartOrder}
        isSubmitting={
          !!resendFincartOrder && sendingFincartOrderId === resendFincartOrder.orderNumber
        }
        onClose={() => {
          if (sendingFincartOrderId) return;
          setResendFincartOrder(null);
        }}
        onConfirm={handleResendToFincart}
      />

      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col-2 sm:flex-row justify-between items-center gap-4 mb-3">
          <h1 className="text-2xl md:text-4xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
            البحث عن الطلبات
          </h1>
          <button
            onClick={() => navigate("/dashboard")}
            className="flex items-center gap-2 bg-white/80 backdrop-blur-sm text-gray-700 px-4 py-2 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200"
          >
            <ChevronRight size={20} />
            العودة للرئيسية
          </button>
        </div>

        {/* Search Section */}
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 mb-2 border border-white/30">
          <div className="flex gap-2 mb-4">
            <button
              type="button"
              onClick={() => setSearchMode("phone")}
              className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-bold transition-all ${
                searchMode === "phone"
                  ? "bg-indigo-600 text-white shadow-md"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              <Phone size={18} />
              رقم الهاتف
            </button>
            <button
              type="button"
              onClick={() => setSearchMode("orderId")}
              className={`flex-1 flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-bold transition-all ${
                searchMode === "orderId"
                  ? "bg-indigo-600 text-white shadow-md"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              <Hash size={18} />
              رقم الطلب
            </button>
          </div>
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 relative">
              {searchMode === "phone" ? (
                <>
                  <input
                    type="text"
                    value={phoneInput}
                    onChange={(e) => setPhoneInput(e.target.value)}
                    onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                    placeholder="أدخل رقم الهاتف للبحث..."
                    className="w-full p-4 pr-14 text-lg border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-indigo-300 focus:border-indigo-400 transition-all bg-white/90"
                  />
                  <Phone className="absolute right-5 top-1/2 transform -translate-y-1/2 text-gray-400" size={24} />
                </>
              ) : (
                <>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={orderIdInput}
                    onChange={(e) => setOrderIdInput(e.target.value.replace(/\D/g, ""))}
                    onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                    placeholder="أدخل رقم الطلب للبحث..."
                    className="w-full p-4 pr-14 text-lg border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-indigo-300 focus:border-indigo-400 transition-all bg-white/90"
                  />
                  <Hash className="absolute right-5 top-1/2 transform -translate-y-1/2 text-gray-400" size={24} />
                </>
              )}
            </div>
            <button
              onClick={handleSearch}
              disabled={isSearching}
              className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-10 py-3 rounded-xl hover:shadow-xl hover:scale-105 transition-all duration-300 font-bold text-lg shadow-lg disabled:opacity-70 flex items-center justify-center gap-2"
            >
              <Search size={24} />
              {isSearching ? "جاري البحث..." : "بحث"}
            </button>
          </div>
        </div>

        {searchResults.length > 0 && (
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-md p-4 mb-4 border border-white/30">
            <div className="flex items-center gap-2 mb-3 font-bold text-slate-700">
              <Filter size={16} />
              مصدر الإنتاج
            </div>
            <div className="flex flex-wrap gap-2">
              {[
                { value: "all", label: "All" },
                { value: "Girabat", label: "Girabat" },
                { value: "TeePlus", label: "TeePlus" },
                { value: "Printlet", label: "Printlet" },
                { value: "unassigned", label: "Unassigned" },
              ].map((option) => (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => setProductionFilter(option.value)}
                  className={`px-3 py-1.5 rounded-xl text-sm font-bold border transition ${
                    productionFilter === option.value
                      ? "bg-indigo-600 text-white border-indigo-600"
                      : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"
                  }`}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Results */}
        {isSearching ? (
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-8">
            <div className="animate-pulse space-y-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="h-16 bg-gray-200 rounded-lg"></div>
              ))}
            </div>
          </div>
        ) : searchError ? (
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-16 text-center">
            <AlertCircle className="mx-auto mb-4 text-red-400" size={64} />
            <p className="text-2xl text-gray-700 mb-2">لا توجد نتائج</p>
            <p className="text-lg text-gray-500">
              {searchMode === "orderId"
                ? "لا يوجد طلب بهذا الرقم"
                : "لا يوجد طلبات بهذا الرقم"}
            </p>
          </div>
        ) : filteredResults.length > 0 ? (
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-white/30 overflow-x-auto">
            {/* ==================== MOBILE CARDS VIEW ==================== */}
            <div className="flex flex-col gap-5 md:hidden">
              {filteredResults.map((order) => {
                const isExpanded = expandedOrders.has(order.orderNumber);
                return (
                  <div
                    key={order.orderNumber}
                    className="rounded-2xl border border-indigo-100 shadow-md overflow-hidden bg-white"
                  >
                    {/* Note Banner */}
                    {order.note ? (
                      <div className="bg-amber-50 border-b border-amber-200 px-4 py-3">
                        <div className="flex items-start gap-2">
                          <MessageSquare size={16} className="text-amber-600 mt-0.5 flex-shrink-0" />
                          <p style={{ fontFamily: "cairo black" }} className="text-[12px] text-amber-800 leading-snug">
                            {order.note}
                          </p>
                        </div>
                        <OrderChangeImagesButton orderId={order.orderNumber} count={order.changeNoteImageCount} />
                      </div>
                    ) : (
                      <div className="bg-gray-50 border-b border-gray-100 px-4 py-2 flex items-center gap-2">
                        <MessageSquare size={14} className="text-gray-300" />
                        <p className="text-sm text-gray-400 italic">لا توجد ملاحظات</p>
                      </div>
                    )}

                    <div className="p-4 space-y-4">
                      {/* Order Number + Status + Date */}
                      <div className="flex items-center justify-between">
                        <span className="font-mono font-bold text-gray-400 text-base flex items-center gap-2">
                          #{order.orderNumber}
                          {order.hasTicket && (
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold bg-emerald-100 text-emerald-800 border border-emerald-300">
                              <CheckCircle size={12} />
                              Ticket{order.ticketCount > 1 ? ` (${order.ticketCount})` : " ✓"}
                            </span>
                          )}
                        </span>
                        <div className="flex flex-col items-end gap-1">
                          <span className={`px-2 py-0.5 rounded-full text-xs font-medium border ${getStatusColor(order.status)}`}>
                            {displayOrderStatus(order.status)}
                          </span>
                          <ProductionSourceBadge source={order.productionSource} />
                          <OrderPaymentBadge order={order} />
                        </div>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="font-semibold text-gray-800 text-base flex items-center gap-1">
                          <User size={14} className="text-gray-400" />
                          {order.name}
                        </span>
                        <span className="text-sm text-gray-400">{order.date}</span>
                      </div>

                      <OrderStatusHistoryButton orderId={order.orderNumber} compact />
                      <CopyTrackingLinkButton orderId={order.orderNumber} compact />
                      <CopyShippingLinkButton shippingTrackLink={order.shippingTrackLink} compact />
                      <ProductionHistoryButton
                        orderId={order.orderNumber}
                        compact
                        onAssigned={(source) =>
                          setSearchResults((prev) =>
                            prev.map((o) =>
                              o.orderNumber === order.orderNumber ? { ...o, productionSource: source } : o
                            )
                          )
                        }
                      />
                      <div className="space-y-2">
                        <div className="flex gap-2">
                          <button
                            onClick={() => setEditingOrderId(order.orderNumber)}
                            className="flex-1 bg-blue-600 text-white py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-1 active:scale-95 transition"
                          >
                            <Edit size={14} />
                            تعديل
                          </button>
                          {canAct && (
                            <button
                              onClick={() => setMergingOrder(order)}
                              className="flex-1 bg-teal-600 text-white py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-1 active:scale-95 transition"
                            >
                              <Merge size={14} />
                              دمج
                            </button>
                          )}
                          {(canTicket || (canSeeTickets && order.hasTicket)) && (
                            <button
                              onClick={() => openTicketForOrder(order)}
                              className={`flex-1 py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-1 active:scale-95 transition ${
                                order.hasTicket
                                  ? "bg-emerald-100 text-emerald-800 border border-emerald-300"
                                  : "bg-rose-600 text-white"
                              }`}
                              title={order.hasTicket ? "فيه تذكرة على الطلب ده" : "إنشاء تذكرة"}
                            >
                              {order.hasTicket ? <CheckCircle size={14} /> : <Ticket size={14} />}
                              {order.hasTicket ? "Ticket ✓" : "Ticket"}
                            </button>
                          )}
                          {canReplace && (
                            <button
                              type="button"
                              onClick={() => setReplacementOrderId(order.orderNumber)}
                              className="flex-1 bg-violet-600 text-white py-2.5 rounded-xl text-sm font-medium"
                            >
                              إنشاء بديل
                            </button>
                          )}
                        </div>
                        <div className="relative flex gap-1">
                          <button
                            onClick={() => handleSendToFincart(order)}
                            disabled={
                              sendingFincartOrderId === order.orderNumber ||
                              !!(order.sentToFincart || order.fincartOrderId)
                            }
                            className={`flex-1 py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-1 active:scale-95 transition disabled:opacity-50 ${
                              order.sentToFincart || order.fincartOrderId
                                ? "bg-emerald-100 text-emerald-800 border border-emerald-300"
                                : "bg-cyan-600 text-white"
                            }`}
                          >
                            {sendingFincartOrderId === order.orderNumber ? (
                              <>
                                <Loader2 size={14} className="animate-spin" />
                                جاري الإرسال...
                              </>
                            ) : order.sentToFincart || order.fincartOrderId ? (
                              <>
                                <CheckCircle size={14} />
                                مُرسل لـ Fincart
                              </>
                            ) : (
                              <>
                                <Truck size={14} />
                                إرسال لـ Fincart
                              </>
                            )}
                          </button>
                          <button
                            type="button"
                            disabled={
                              !canAct ||
                              !orderCanEnterFulfillment(order)
                            }
                            title={
                              !orderCanEnterFulfillment(order)
                                ? "Payment Pending"
                                : "تحديث الحالة إلى Printlet"
                            }
                            onClick={() => handleUpdateStatus(order.orderNumber, "Printlet")}
                            className="flex-1 py-2.5 rounded-xl text-sm font-medium bg-fuchsia-600 text-white disabled:opacity-50"
                          >
                            Printlet
                          </button>
                          {(order.sentToFincart || order.fincartOrderId) && (
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                setFincartMenuOrderId((prev) =>
                                  prev === order.orderNumber ? null : order.orderNumber
                                );
                              }}
                              className="px-2 py-2.5 rounded-xl bg-emerald-50 text-emerald-800 border border-emerald-300 active:scale-95 transition"
                              title="خيارات Fincart"
                            >
                              <MoreVertical size={16} />
                            </button>
                          )}
                          {fincartMenuOrderId === order.orderNumber && (
                            <>
                              <div
                                className="fixed inset-0 z-40"
                                onClick={() => setFincartMenuOrderId(null)}
                              />
                              <div className="absolute left-0 top-full mt-1 z-50 min-w-[200px] bg-white rounded-xl shadow-xl border border-gray-200 py-1 overflow-hidden">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setFincartMenuOrderId(null);
                                    setResendFincartOrder(order);
                                  }}
                                  className="w-full text-right px-4 py-2.5 text-sm text-gray-800 hover:bg-cyan-50 flex items-center gap-2"
                                >
                                  <RefreshCw size={14} className="text-cyan-600" />
                                  إعادة إرسال بـ ID جديد
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>

                      {/* Phone Numbers - BIG & TAPPABLE */}
                      <div className="space-y-3">
                        <div className="space-y-1.5">
                          <ViewConversationButton
                            order={order}
                            phone={order.phoneNumber}
                            templatePreset="search"
                            canSend={canAct}
                            compact
                            className="w-full"
                          />
                          <button
                            type="button"
                            onClick={() => copyToClipboard(order.phoneNumber)}
                            title="اضغط لنسخ الرقم"
                            className="flex items-center gap-3 bg-green-50 border border-green-200 rounded-xl px-2 py-1 text-green-700 active:bg-green-100 transition w-full text-right"
                          >
                            <Phone size={20} className="text-green-600 flex-shrink-0" />
                            <span className="text-lg font-bold tracking-wide" style={{ fontFamily: "monospace" }}>
                              {order.phoneNumber}
                            </span>
                          </button>
                        </div>
                        {order.phoneNumber2 && order.phoneNumber2 !== "غير معروف" && (
                          <div className="space-y-1.5">
                            <ViewConversationButton
                              order={order}
                              phone={order.phoneNumber2}
                              templatePreset="search"
                              canSend={canAct}
                              compact
                              className="w-full"
                              label="عرض محادثة الرقم التاني"
                            />
                            <button
                              type="button"
                              onClick={() => copyToClipboard(order.phoneNumber2)}
                              title="اضغط لنسخ الرقم"
                              className="flex items-center gap-3 bg-green-50 border border-green-200 rounded-xl px-2 py-1 text-green-700 active:bg-green-100 transition w-full text-right"
                            >
                              <Phone size={20} className="text-green-600 flex-shrink-0" />
                              <span className="text-lg font-bold tracking-wide" style={{ fontFamily: "monospace" }}>
                                {order.phoneNumber2}
                              </span>
                            </button>
                          </div>
                        )}
                      </div>

                      {/* Address */}
                      <div className="bg-gray-50 rounded-xl p-3 space-y-1">
                        <div className="flex items-start gap-2">
                          <MapPin size={14} className="text-gray-500 mt-0.5 flex-shrink-0" />
                          <span style={{ fontFamily: "cairo black" }} className="text-[12px] text-gray-700 leading-snug">
                            {order.address}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Map size={14} className="text-purple-500" />
                          <span className="text-base font-bold text-purple-600">{order.state}</span>
                        </div>
                      </div>

                      {(order.sentToFincart || order.fincartOrderId) && (
                        <ShippingTimeline orderId={order.orderNumber} compact />
                      )}

                      {canAct ? (
                        <>
                          {/* Row 1: Quick actions */}
                          <div className="grid grid-cols-2 gap-2">
                            <button
                              onClick={() => handleNormalChanges(order.orderNumber)}
                              className="bg-purple-600 text-white py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-1 active:scale-95 transition"
                            >
                              <RotateCcw size={14} />
                              تغييرات
                            </button>
                            <button
                              onClick={() => handlePartialPaymentClick(order.orderNumber, order.total)}
                              className="bg-amber-500 text-white py-2.5 rounded-xl text-sm font-medium flex items-center justify-center gap-1 active:scale-95 transition"
                            >
                              <CreditCard size={14} />
                              دفع ديبوزت
                            </button>
                          </div>

                          {/* Row 2: Dropdown menus */}
                          <div className="grid grid-cols-2 gap-2">
                            {adminUser && (
                              <ActionMenu
                                icon={Printer}
                                label="الإنتاج"
                                color="indigo"
                                align="right"
                                size="sm"
                                items={productionMenuItems(order)}
                              />
                            )}
                            <ActionMenu
                              icon={Package}
                              label="حالة الطلب"
                              color="emerald"
                              align={adminUser ? "left" : "right"}
                              size="sm"
                              items={orderStatusMenuItems(order)}
                            />
                          </div>

                          {/* Row 3: Start conversation */}
                          <StartConversationButton
                            order={order}
                            className="w-full py-2.5 rounded-xl"
                            hidden={!canAct}
                          />

                          {/* Row 4: Danger zone */}
                          <ActionMenu
                            icon={MoreVertical}
                            label="خيارات أخرى"
                            color="red"
                            align="left"
                            size="sm"
                            items={dangerMenuItems(order)}
                          />
                        </>
                      ) : (
                        <p className="text-center text-sm text-slate-500 bg-slate-50 rounded-xl py-2 border border-slate-200">عرض فقط</p>
                      )}

                      {/* Total + collapse toggle */}
                      <button
                        onClick={() => toggleExpand(order.orderNumber)}
                        className="w-full flex items-center justify-between bg-green-50 rounded-xl px-3 py-2 border border-green-200 active:bg-green-100 transition"
                      >
                        <div className="flex items-center gap-2">
                          {isExpanded ? (
                            <ChevronUp size={20} className="text-green-600" />
                          ) : (
                            <ChevronDown size={20} className="text-green-600" />
                          )}
                          <span className="text-gray-500 text-sm">
                            {isExpanded ? "إخفاء التفاصيل" : "المنتجات والإجراءات"}
                          </span>
                        </div>
                        <span className="text-xl font-bold text-green-600">{order.total} ج.م</span>
                      </button>

                      {/* ── Collapsible section ── */}
                      {isExpanded && (
                        <div className="space-y-3">
                          {/* Products */}
                          <div className="space-y-1">
                            {order.items.map((item, index) => (
                              <div key={`${item.id}-${index}`} className="bg-purple-50 rounded-lg p-2 border border-purple-100">
                                <div className="font-medium text-purple-700 text-xs leading-tight">{item.name}</div>
                                <NamedPieceBadge item={item} className="mt-1" />
                                <div style={{ fontFamily: "cairo black" }} className="text-[10px] text-gray-600 leading-tight">{item.type}</div>
                                {renderPieceActions(order, item)}
                                <div className="flex items-center gap-1 mt-1 flex-wrap">
                                  <span className={`text-[10px] px-1.5 py-[2px] rounded font-mono ${item.code.startsWith("CUSTOM") ? "bg-green-100" : "bg-gray-100"}`}>
                                    {item.code}
                                  </span>
                                  {item.driveLink && (
                                    <div className="flex items-center gap-1">
                                      <a
                                        href={item.driveLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-purple-600 hover:text-purple-800"
                                        title="فتح الرابط"
                                      >
                                        <LinkIcon size={12} />
                                      </a>
                                      {item.code.startsWith("CUSTOM") && (
                                        <button
                                          onClick={() => handleDownload(item.driveLink, `${order.orderNumber}-${item.id}.jpg`)}
                                          className="flex items-center gap-1 text-white px-2 py-[2px] rounded text-[10px]"
                                          style={{ backgroundColor: "#15d225" }}
                                        >
                                          <Download size={10} />
                                          Download
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                            {renderAddPiece(order)}
                          </div>

                          {/* Copy Buttons */}
                          <div className="space-y-2">
                            <p className="text-xs font-bold text-gray-500 px-1">نسخ</p>
                            <div className="grid grid-cols-3 gap-2">
                              <button
                                onClick={() => handleCopyOrderInfo(order)}
                                className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white py-2.5 rounded-xl text-xs font-bold flex items-center justify-center gap-1 active:scale-95 transition"
                              >
                                <CopyIcon size={12} />
                                العميل
                              </button>
                              <button
                                onClick={() => handleCopyItems(order)}
                                className="bg-gradient-to-r from-purple-500 to-pink-500 text-white py-2.5 rounded-xl text-xs font-bold flex items-center justify-center gap-1 active:scale-95 transition"
                              >
                                <Layers size={12} />
                                المنتجات
                              </button>
                              <button
                                onClick={() => handleCopyAllExcelDataNoReference(order)}
                                disabled={!orderCanEnterFulfillment(order)}
                                title={orderCanEnterFulfillment(order) ? "نسخ (TeePlus)" : "Payment Pending"}
                                className="bg-gradient-to-r from-green-500 to-emerald-500 text-white py-2.5 rounded-xl text-xs font-bold flex items-center justify-center gap-1 active:scale-95 transition disabled:opacity-40 disabled:cursor-not-allowed"
                              >
                                <Copy size={12} />
                                نسخ (TeePlus)
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* ── End collapsible ── */}
                    </div>
                  </div>
                );
              })}
            </div>
            {/* ==================== END MOBILE CARDS ==================== */}

            {/* Desktop Table */}
            <table className="w-full min-w-[1200px] table-auto hidden md:table">
              <thead>
                <tr className="bg-gradient-to-r from-indigo-50 to-purple-50 border-b-2 border-indigo-200">
                  <th className="p-4 text-center font-bold text-indigo-800">رقم الطلب</th>
                  <th className="p-4 text-right font-bold text-indigo-800">بيانات العميل</th>
                  <th className="p-4 text-right font-bold text-indigo-800">المنتجات</th>
                  <th className="p-4 text-center font-bold text-indigo-800 min-w-[140px]">الحالة</th>
                  <th className="p-4 text-right font-bold text-indigo-800">ملاحظات</th>
                  <th className="p-4 text-center font-bold text-indigo-800">نسخ</th>
                  <th className="p-4 text-center font-bold text-indigo-800 min-w-[170px]">الإجراءات</th>
                </tr>
              </thead>
              <tbody>
                {filteredResults.map((order) => (
                  <tr key={order.orderNumber} className="border-b border-gray-200 hover:bg-white/60 transition-colors">
                    <td className="p-4 text-center align-top">
                      <span className="font-mono font-bold text-indigo-600 flex flex-col items-center gap-1">
                        #{order.orderNumber}
                        {order.hasTicket && (
                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold bg-emerald-100 text-emerald-800 border border-emerald-300">
                            <CheckCircle size={12} />
                            Ticket{order.ticketCount > 1 ? ` (${order.ticketCount})` : " ✓"}
                          </span>
                        )}
                      </span>
                    </td>
                    <td className="p-4 align-top">
                      <div className="space-y-2">
                        {(adminUser || canTicket) && (
                          <div className="flex flex-col gap-2">
                            <div className="flex gap-2">
                              {canAct && (
                              <button
                                onClick={() => setEditingOrderId(order.orderNumber)}
                                className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 text-sm font-medium transition-all"
                              >
                                <div className="flex items-center justify-center gap-1">
                                  <Edit size={14} />
                                  تعديل
                                </div>
                              </button>
                              )}
                              {adminUser && canAct && (
                                <button
                                  onClick={() => setMergingOrder(order)}
                                  className="flex-1 bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 text-sm font-medium transition-all"
                                >
                                  <div className="flex items-center justify-center gap-1">
                                    <Merge size={14} />
                                    دمج
                                  </div>
                                </button>
                              )}
                              {(canTicket || (canSeeTickets && order.hasTicket)) && (
                                <button
                                  onClick={() => openTicketForOrder(order)}
                                  className={`flex-1 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                                    order.hasTicket
                                      ? "bg-emerald-100 text-emerald-800 border border-emerald-300 hover:bg-emerald-200"
                                      : "bg-rose-600 text-white hover:bg-rose-700"
                                  }`}
                                  title={order.hasTicket ? "فيه تذكرة على الطلب ده" : "إنشاء تذكرة"}
                                >
                                  <div className="flex items-center justify-center gap-1">
                                    {order.hasTicket ? <CheckCircle size={14} /> : <Ticket size={14} />}
                                    {order.hasTicket ? "Ticket ✓" : "Ticket"}
                                  </div>
                                </button>
                              )}
                              {canReplace && (
                                <button
                                  type="button"
                                  onClick={() => setReplacementOrderId(order.orderNumber)}
                                  className="flex-1 bg-violet-600 text-white px-4 py-2 rounded-lg text-sm font-medium"
                                >
                                  إنشاء بديل
                                </button>
                              )}
                            </div>
                           
                            {adminUser && (
                            <div className="relative flex gap-1">
                            <button
                                type="button"
                                disabled={
                                  !canAct ||
                                  !orderCanEnterFulfillment(order)
                                }
                                title={
                                  !orderCanEnterFulfillment(order)
                                    ? "Payment Pending"
                                    : "تحديث الحالة إلى Printlet"
                                }
                                onClick={() => handleUpdateStatus(order.orderNumber, "Printlet")}
                                className="px-3 py-2 rounded-lg text-sm font-medium bg-fuchsia-600 text-white disabled:opacity-50"
                              >
                                Printlet
                              </button>
                              <button
                                onClick={() => handleSendToFincart(order)}
                                disabled={
                                  sendingFincartOrderId === order.orderNumber ||
                                  !!(order.sentToFincart || order.fincartOrderId)
                                }
                                className={`flex-1 px-4 py-2 rounded-lg text-sm font-medium transition-all disabled:opacity-50 ${
                                  order.sentToFincart || order.fincartOrderId
                                    ? "bg-emerald-100 text-emerald-800 border border-emerald-300"
                                    : "bg-cyan-600 text-white hover:bg-cyan-700"
                                }`}
                              >
                                <div className="flex items-center justify-center gap-1">
                                  {sendingFincartOrderId === order.orderNumber ? (
                                    <>
                                      <Loader2 size={14} className="animate-spin" />
                                      جاري الإرسال...
                                    </>
                                  ) : order.sentToFincart || order.fincartOrderId ? (
                                    <>
                                      <CheckCircle size={14} />
                                      Fincart ✓
                                    </>
                                  ) : (
                                    <>
                                      <Truck size={14} />
                                      إرسال لـ Fincart
                                    </>
                                  )}
                                </div>
                              </button>
                              
                              {(order.sentToFincart || order.fincartOrderId) && (
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setFincartMenuOrderId((prev) =>
                                      prev === order.orderNumber ? null : order.orderNumber
                                    );
                                  }}
                                  className="px-2 py-2 rounded-lg bg-emerald-50 text-emerald-800 border border-emerald-300 hover:bg-emerald-100 transition"
                                  title="خيارات Fincart"
                                >
                                  <MoreVertical size={16} />
                                </button>
                              )}
                              {fincartMenuOrderId === order.orderNumber && (
                                <>
                                  <div
                                    className="fixed inset-0 z-40"
                                    onClick={() => setFincartMenuOrderId(null)}
                                  />
                                  <div className="absolute left-0 top-full mt-1 z-50 min-w-[200px] bg-white rounded-xl shadow-xl border border-gray-200 py-1 overflow-hidden">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setFincartMenuOrderId(null);
                                        setResendFincartOrder(order);
                                      }}
                                      className="w-full text-right px-4 py-2.5 text-sm text-gray-800 hover:bg-cyan-50 flex items-center gap-2"
                                    >
                                      <RefreshCw size={14} className="text-cyan-600" />
                                      إعادة إرسال بـ ID جديد
                                    </button>
                                  </div>
                                </>
                              )}
                            </div>
                            )}
                          </div>
                        )}
                        {(order.sentToFincart || order.fincartOrderId) && (
                          <div className="mt-2">
                            <ShippingTimeline orderId={order.orderNumber} compact />
                          </div>
                        )}
                        <div className="flex items-center gap-2">
                          <User size={16} className="text-indigo-600" />
                          <span style={{ fontFamily: "cairo black" }} className="text-sm">{order.name}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Phone size={16} className="text-green-600" />
                          <div className="flex flex-col gap-2 w-full">
                            <div className="space-y-1">
                              <ViewConversationButton
                                order={order}
                                phone={order.phoneNumber}
                                templatePreset="search"
                                canSend={canAct}
                                compact
                                className="w-full"
                              />
                              <span onClick={() => copyToClipboard(order.phoneNumber)}
                                className="text-green-600 hover:underline cursor-pointer block" title="اضغط لنسخ الرقم">{order.phoneNumber}</span>
                            </div>
                            {order.phoneNumber2 !== "غير معروف" && (
                              <div className="space-y-1">
                                <ViewConversationButton
                                  order={order}
                                  phone={order.phoneNumber2}
                                  templatePreset="search"
                                  canSend={canAct}
                                  compact
                                  className="w-full"
                                  label="عرض محادثة الرقم التاني"
                                />
                                <span onClick={() => copyToClipboard(order.phoneNumber2)}
                                  className="text-green-600 hover:underline cursor-pointer block" title="اضغط لنسخ الرقم">{order.phoneNumber2}</span>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <MapPin size={16} className="text-purple-600" />
                          <span style={{ fontFamily: "cairo black" }} className="text-[13px]">{order.address}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Map size={16} className="text-orange-600" />
                          <span>{order.state}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <DollarSign size={16} className="text-green-600" />
                          <span style={{ fontFamily: "cairo black" }} className="text-2xl font-bold text-green-600">{order.total} ج.م</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <Calendar size={16} className="text-gray-600" />
                          <span className="text-lg">{order.date}</span>
                        </div>
                      </div>
                    </td>
                    <td className="p-4">
                      {order.items.map((item, index) => (
                        <div key={`${item.id}-${index}`} className="mb-3">
                          <div className="flex items-start gap-2">
                            <div className="flex-1">
                              <div className="font-medium text-purple-700">{item.name}</div>
                              <NamedPieceBadge item={item} className="mt-1" />
                              <div style={{ fontFamily: "cairo black" }} className="text-[13px] text-black-600">{item.type}</div>
                              {renderPieceActions(order, item)}
                              <div className="flex items-center gap-2 mt-1">
                                {item.code.startsWith("CUSTOM") && (
                                  <span className="text-xs bg-green-100 px-2 py-1 rounded font-mono">{item.code}</span>
                                )}
                                {!item.code.startsWith("CUSTOM") && (
                                  <span className="text-xs bg-gray-100 px-2 py-1 rounded font-mono">{item.code}</span>
                                )}
                                {item.driveLink && (
                                  <div className="flex items-center gap-1">
                                    <a href={item.driveLink} target="_blank" rel="noopener noreferrer"
                                      className="text-purple-600 hover:text-purple-800 transition-transform hover:scale-110" title="فتح الرابط">
                                      <LinkIcon size={16} />
                                    </a>
                                    {item.code.startsWith("CUSTOM") && (
                                      <button onClick={() => handleDownload(item.driveLink, `${order.orderNumber}-${item.id}.jpg`)}
                                        className="flex items-center gap-2 text-white hover:text-white transition-transform hover:scale-110 px-3 py-2"
                                        title="تحميل الصورة" style={{ backgroundColor: "#15d225", borderRadius: "4px" }}>
                                        <Download size={16} />
                                        <span className="text-sm">Download</span>
                                      </button>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {index < order.items.length - 1 && <hr className="my-2 border-gray-200" />}
                        </div>
                      ))}
                      {renderAddPiece(order)}
                    </td>
                    <td className="p-4 text-center align-top">
                      <span className={`inline-block px-3 py-1 rounded-full text-lg font-medium border ${getStatusColor(order.status)}`}>
                        {displayOrderStatus(order.status)}
                      </span>
                      <div className="mt-2 flex justify-center">
                        <ProductionSourceBadge source={order.productionSource} />
                      </div>
                      <div className="mt-2 flex justify-center">
                        <OrderPaymentBadge order={order} />
                      </div>
                      <div className="mt-2">
                        <OrderStatusHistoryButton orderId={order.orderNumber} compact />
                      </div>
                      <div className="mt-2">
                        <ProductionHistoryButton
                          orderId={order.orderNumber}
                          compact
                          onAssigned={(source) =>
                            setSearchResults((prev) =>
                              prev.map((o) =>
                                o.orderNumber === order.orderNumber ? { ...o, productionSource: source } : o
                              )
                            )
                          }
                        />
                      </div>
                    </td>
                    <td className="p-4 align-top max-w-[150px]">
                      <p style={{ fontFamily: "cairo black" }} className="text-[16px]">{order.note || "—"}</p>
                      <OrderChangeImagesButton orderId={order.orderNumber} count={order.changeNoteImageCount} />
                    </td>
                    <td className="p-4 align-top">
                      <div className="flex flex-col gap-2">
                        <CopyTrackingLinkButton orderId={order.orderNumber} />
                        <CopyShippingLinkButton shippingTrackLink={order.shippingTrackLink} />
                        <button onClick={() => handleCopyOrderInfo(order)}
                          className="flex items-center justify-center gap-1 bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-6 py-3 rounded-lg hover:shadow-md hover:scale-105 transition text-sm">
                          <CopyIcon size={16} /> العميل
                        </button>
                        <button onClick={() => handleCopyItems(order)}
                          className="flex items-center justify-center gap-1 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-3 rounded-lg hover:shadow-md hover:scale-105 transition text-sm">
                          <Layers size={16} /> المنتجات
                        </button>
                        <button onClick={() => handleCopyAllExcelDataNoReference(order)}
                          disabled={!orderCanEnterFulfillment(order)}
                          title={orderCanEnterFulfillment(order) ? "نسخ (TeePlus)" : "Payment Pending"}
                          className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white px-3 py-4 rounded-xl hover:shadow-lg hover:scale-105 transition-all duration-300 text-sm font-bold flex items-center justify-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:scale-100">
                          <Copy size={16} /> نسخ (TeePlus)
                        </button>
                      </div>
                    </td>
                    <td className="p-4 align-top">
                      {canAct ? (
                        <div className="flex flex-col gap-2 min-w-[150px]">
                          {/* Quick actions */}
                          <button
                            onClick={() => handleNormalChanges(order.orderNumber)}
                            className="flex items-center justify-center gap-1.5 bg-purple-600 text-white px-3 py-2 rounded-lg hover:bg-purple-700 text-sm font-medium transition"
                          >
                            <RotateCcw size={14} />
                            تغييرات
                          </button>
                          <button
                            onClick={() => handlePartialPaymentClick(order.orderNumber, order.total)}
                            className="flex items-center justify-center gap-1.5 bg-amber-500 text-white px-3 py-2 rounded-lg hover:bg-amber-600 text-sm font-medium transition"
                          >
                            <CreditCard size={14} />
                            دفع ديبوزت
                          </button>

                          {/* Dropdown: Production (admin only) */}
                          {adminUser && (
                            <ActionMenu
                              icon={Printer}
                              label="الإنتاج"
                              color="indigo"
                              align="right"
                              items={productionMenuItems(order)}
                            />
                          )}

                          {/* Dropdown: Order status */}
                          <ActionMenu
                            icon={Package}
                            label="حالة الطلب"
                            color="emerald"
                            align="right"
                            items={orderStatusMenuItems(order)}
                          />

                          <StartConversationButton order={order} className="w-full" hidden={!canAct} />

                          {/* Dropdown: Danger */}
                          <ActionMenu
                            icon={MoreVertical}
                            label="خيارات أخرى"
                            color="red"
                            align="right"
                            items={dangerMenuItems(order)}
                          />
                        </div>
                      ) : (
                        <p className="text-center text-sm text-slate-500">عرض فقط</p>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : phoneInput && !isSearching ? (
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-16 text-center">
            <Package className="mx-auto mb-4 text-gray-400" size={64} />
            <p className="text-2xl text-gray-700 mb-2">لا توجد طلبات</p>
            <p className="text-lg text-gray-500">
              {searchMode === "orderId"
                ? "لم يتم العثور على طلب بهذا الرقم"
                : "لم يتم العثور على طلبات بهذا الرقم"}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SearchOrders;